import { FieldDataService } from "./../../services/fieldData/field-data.service";
import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DeviceLabelsModalComponent } from "../device-labels-modal/device-labels-modal.component";
import { LoginService } from "src/app/services/login/login.service";
import moment from "moment-timezone";
import { FakeServiceService } from "../../services/fakeService/fake-service.service";
import * as _ from "lodash";
import { DataTypeService } from "src/app/services/datatype/data-type.service";
import { NodeAlarmComponent } from "../node-alarm/node-alarm.component";

@Component({
  selector: "app-estructura-campo-nav",
  templateUrl: "./estructuraCampoNav.component.html",
  styleUrls: ["./estructuraCampoNav.component.scss"],
})
export class EstructuraCampoNavComponent implements OnInit, OnDestroy {
  // Creamos las variables para poder acceder a luego a ellas:
  mySubscription: any;
  querySubscription: any;
  sub: any;
  subStream: any;
  uuid: string;
  gatewayActual: any;
  atributosLabel: any[] = [];
  labelsMapping: any;
  lmPing: any;

  // para el 'GatewayFrom'
  gatewaysFrom: any;
  arregloGatewaysFrom: any;
  displayedColumnsFrom: string[] = ["nombre"];
  dataSourceFrom: MatTableDataSource<any>;
  @ViewChild("TableFromPaginator", { static: true })
  tableFromPaginator: MatPaginator;

  // para el 'GatewayTo'
  gatewaysTo: any;
  arregloGatewaysTo: any;
  // displayedColumnsTo: string[] = ['nombre', 'last', 'comunicacion', 'problema_leve', 'problema_grave'];
  displayedColumnsTo: string[] = ["nombre", "last", "sources"];

  dataSourceTo: MatTableDataSource<any>;
  @ViewChild("TableToPaginator") tableToPaginator: MatPaginator;

  // para el 'Source'
  sources: any;
  displayedColumnsSources: string[] = ["nombre", "topic", "entradas", "modelo"];
  dataSourceSources: any;
  @ViewChild("TableSourcesPaginator") tableSourcesPaginator: MatPaginator;

  // Para el momento actual:
  timeStamp = new Date().getTime() * 1000000;
  topLimitAlerta: any; // De momento establecido a 1 hora
  time: number;

  timezone: string;
  fromPlotly: number;
  toPlotly: number;
  graphConfig: any;

  // para las alarmas de nodos:
  nodesAlarmsArray: any;
  arreglo: any;
  nodesSilencedsArray: any;

  // puntos con alarmas:
  gatewaysToDownCount: number;
  sourcesDownCount: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataService: FieldDataService,
    private toastrservice: ToastrService,
    private dialog: MatDialog,
    private loginService: LoginService,
    private fakeService: FakeServiceService,
    private dataTypeService: DataTypeService
  ) {}

  ngOnInit() {
    // Hacemos que el componente sea renavegable
    this.renavigate();
    // Tramos los datos del servicio que hemos creado para ello
    this.getData();
    // Para el componente de plotly que mostrará el ping
    this.timezone = this.loginService.currentUserValue.timeZone;
    this.toPlotly = moment.unix(new Date()).tz(this.timezone).unix();
    this.fromPlotly = this.toPlotly - 6 * Math.pow(10, 8); // Le quitamos 1 semana al momento actual
    this.graphConfig = {
      dispositivos: [this.uuid],
      from: this.fromPlotly,
      to: this.toPlotly,
      limit: null,
      tipoDato: ["90dd4a79-9005-466c-a32f-f094c5834b4f"],
      type: "scattergl",
      mode: "lines+points",
      layout: {
        width: 640,
        height: 250,
        margin: {
          l: 50,
          r: 25,
          b: 75,
          t: 0,
          pad: 4,
        },
      },
    };
  }
  // Funcion para poder 'renavegar' por el mismo componente:
  renavigate() {
    // Con las dos suscripciones de debajo, hacemos creer a angular que no hemos visitado el componente
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Para hacer creer a angular que no hemos estado en el componente
        this.router.navigated = false;
      }
    });
    // Nos suscribimos al parametro de uuid del link para saber a que dispositivo tenemos que navegar
    // a continuacion.
    this.activatedRoute.params.subscribe((params) => {
      // const uuid = params['uuid'];
      this.uuid = params.uuid;
    });
  }

  // Tramos los datos del servicio que hemos creado
  getData() {
    this.getAtributosLabels();
    // Nos traemos la informacion de los gateways que cuelgan desde el servicio
    this.dataService.getGatewaysFrom(this.uuid).subscribe((data) => {
      this.dataSourceFrom = data;
      data.data = data.data.filter((elem) => elem.sourcesTotal > 0);
      this.dataSourceFrom.paginator = this.tableFromPaginator;
    });

    // Nos traemos la informacion de los sources desde el servicio
    this.getDataSources();

    // Nos traemos la informacion del gateway actual desde el servicio
    this.dataService.getGatewayActual(this.uuid).subscribe((data) => {
      this.gatewayActual = data;
      this.getAlarms();
    });

    // Obtener información del ping:
    this.dataService.getLMping(this.uuid).subscribe((data) => {
      if (data) {
        this.lmPing = data;
        this.dataTypeService
          .findDato(this.lmPing.alive.uuid)
          .subscribe((data) =>
            this.graphConfig.tipoDato.push(data.esConnection.edges[0].node.uuid)
          );
      }
    });

    // Cargamos la configuración del limite de tiempo para mostrar una alerta
    // al usuario sobre el estado del gateway:
    this.getGatewaysTo();
  }

  getDataSources() {
    this.arregloGatewaysFrom = [];
    // this.dataSourceSources = new MatTableDataSource();
    this.sourcesDownCount = 0;
    this.dataService.getConfigFieldData().subscribe((data) => {
      this.topLimitAlerta = data.limiteAlarma;
      this.time = this.timeStamp - this.topLimitAlerta;
      this.dataService.getSources(this.uuid).subscribe((data) => {
        this.dataSourceSources = data;
        if (this.dataSourceSources) {
          for (let i = 0; i < this.dataSourceSources.length; i++) {
            this.arregloGatewaysFrom[i] = {
              indice: i,
              data: this.dataSourceSources[i],
            };
            let count = 0;
            let countRezagadas = 0;
            let countNotNull = 0;
            for (
              let j = 0;
              j < this.dataSourceSources[i].entradasConnection.edges.length;
              j++
            ) {
              if (
                this.dataSourceSources[i].entradasConnection.edges[j]
                  .lastFecha === null
              ) {
                count = count + 1;
              }
              if (
                this.dataSourceSources[i].entradasConnection.edges[j]
                  .lastFecha != null
              ) {
                countNotNull = countNotNull + 1;
              }
              if (
                this.dataSourceSources[i].entradasConnection.edges[j]
                  .lastFecha != null
              ) {
                if (
                  this.timeStamp -
                    this.dataSourceSources[i].entradasConnection.edges[j]
                      .lastFecha >
                  this.topLimitAlerta
                ) {
                  countRezagadas = countRezagadas + 1;
                }
              }
            }
            this.dataService
              .getNodeAlarms(this.dataSourceSources[i].uuid)
              .subscribe((data) => {
                if (data.some((elem) => elem.lastEntrada)) {
                  this.arregloGatewaysFrom[i].alarmadosCount = data.filter(
                    (elem) => elem.alarmado && !elem.silenciado
                  ).length;
                  this.sourcesDownCount++;
                }
              });

            this.arregloGatewaysFrom[i].entradasNulas = count;
            this.arregloGatewaysFrom[i].entradasRezagadas = countRezagadas;
            this.arregloGatewaysFrom[i].countNotNull = countNotNull;
            this.arregloGatewaysFrom[i].entradasTotales =
              this.dataSourceSources[i].entradasConnection.edges.length;
          }
          this.dataSourceSources = new MatTableDataSource(
            this.arregloGatewaysFrom.filter((elem) => elem.countNotNull > 0)
          );
          this.dataSourceSources.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
              return this.nestedFilterCheck(currentTerm, data, key);
            };
            const dataStr = Object.keys(data)
              .reduce(accumulator, "")
              .toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
          };
          this.dataSourceSources.paginator = this.tableSourcesPaginator;
        }
      });
    });
  }

  getGatewaysTo() {
    this.gatewaysToDownCount = 0;
    this.dataService.getConfigFieldData().subscribe((data) => {
      this.topLimitAlerta = data.limiteAlarma;
      this.time = this.timeStamp - this.topLimitAlerta;
      // también se puede aceder como data["limiteAlarma"]
      this.arregloGatewaysTo = [];
      this.subStream = this.dataService
        .getGatewaysTo(this.uuid)
        .subscribe((data) => {
          this.gatewaysTo = data;
          for (let i = 0; i < this.gatewaysTo.length; i++) {
            this.arregloGatewaysTo[i] = {
              indice: i,
              data: this.gatewaysTo[i],
            };
            this.dataService
              .getsourceRezagados(this.gatewaysTo[i].uuid, this.time)
              .subscribe((data) => {
                this.arregloGatewaysTo[i].sourcesRezagados = data;
              });
            this.dataService
              .getNodeAlarms(this.gatewaysTo[i].uuid)
              .subscribe((data) => {
                if (data.some((elem) => elem.lastEntrada)) {
                  this.arregloGatewaysTo[i].alarmadosCount = data.filter(
                    (elem) => elem.lastEntrada
                  ).length;
                  this.gatewaysToDownCount++;
                }
              });
          }
          this.dataSourceTo = new MatTableDataSource(
            this.arregloGatewaysTo.filter((elem) => elem.data.sourcesTotal > 0)
          );
          this.dataSourceTo.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
              return this.nestedFilterCheck(currentTerm, data, key);
            };
            const dataStr = Object.keys(data)
              .reduce(accumulator, "")
              .toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
          };
          // this.dataSourceTo.data = this.dataSourceTo.data.filter(elem => elem.sourcesTotal > 0)
          // this.dataSourceTo.paginator = this.tableToPaginator;
          this.dataSourceTo.paginator = this.tableToPaginator;
        });
    });
  }

  // para filtros a distinto nivel en las tablas
  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === "object") {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  // Funcion para aplicar los filtros
  applyFilterTo(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceTo.filter = filterValue.trim().toLowerCase();
  }

  applyFilterFrom(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFrom.filter = filterValue.trim().toLowerCase();
  }

  applyFilterSources(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceSources.filter = filterValue.trim().toLowerCase();
  }

  // función para alertar de que el uuid ha sido copiado al portapeles
  //TODO: copiado(event: Event) {
  copiado(event) {
    if (event) {
      this.toastrservice.info("", "Copiado al portapapeles con éxito", {
        closeButton: true,
        timeOut: 2000,
        positionClass: "toast-top-center",
      });
    }
  }

  // Para volver al estado anterior de la navegacion
  previousState() {
    window.history.back();
  }

  //feature-3-editar-elementos-de-campo

  getAtributosLabels() {
    this.atributosLabel = [];
    // Get atributos Label
    this.fakeService.getDeviceLabelsMapping().subscribe((data) => {
      this.labelsMapping = data.deviceLabelsMapping;
    });
    this.dataService.getAtributosGateWay(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });
    this.dataService.getAtributosLMPing(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });
    this.dataService.getAtributosDispositivo(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });
    this.dataService.getAtributosMbBus(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });
    this.dataService.getAtributosTcpDevice(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });
    this.dataService.getAtributosMbRtuDevice(this.uuid).subscribe((data) => {
      if (data) {
        Object.entries(data).forEach((atributo) => {
          if (
            atributo[0] != "__typename" &&
            !_.some(this.atributosLabel, (x) => x[0] == atributo[0])
          )
            this.atributosLabel.push(atributo);
        });
      }
    });

    // Fin atributosl Label
  }
  openDialog() {
    const dialogRef = this.dialog.open(DeviceLabelsModalComponent, {
      data: {
        atributosLabel: _.uniqWith(this.atributosLabel, _.isEqual),
        labelsMapping: this.labelsMapping,
        uuid: this.uuid,
        result: "",
      },
      minWidth: 270,
    });
    dialogRef.afterClosed().subscribe((dispositivo) => {
      if (!_.isEmpty(dispositivo)) {
        dispositivo = { ...dispositivo, actualuuid: this.uuid };
        this.guardarAtributosLabels(dispositivo);
        this.getData();
      }
    });
  }

  openAlertsComponent(filterMode: string) {
    const dialogRef = this.dialog.open(NodeAlarmComponent, {
      data: {
        uuid: this.uuid,
        componentMode: "source",
        nodeType: "nodeLink",
        title: "Nodos con datos en estado:",
        filterMode: filterMode,
      },
      height: "75%",
      width: "85%",
      minWidth: 270,
    });
    dialogRef.afterClosed().subscribe((data) => {
      this.getData();
    });
  }

  silenceAlarm() {
    alert("Alarma silenciada hasta volver a rearmarla");
  }

  rearmaAlarmaNodo() {
    alert(
      "Alarma rearmada, se volverá a notificar cualquier incidencia sobre este nodo y su estructura"
    );
  }

  getAlarms() {
    this.dataService.getNodeAlarms(this.uuid).subscribe((data) => {
      this.nodesAlarmsArray = data.filter(
        (elem) => elem.lastEntrada.dato.alarmado
      );
      this.nodesSilencedsArray = data.filter(
        (elem) => elem.lastEntrada.dato.silenciado
      );
    });
  }

  guardarAtributosLabels(dispositivo) {
    this.gatewayActual.labels.forEach((label) => {
      switch (label) {
        case "Dispositivo": {
          this.dataService.actualizarDispositivo(dispositivo);
          break;
        }
        case "Gateway": {
          this.dataService.actualizarGateway(dispositivo);
          break;
        }
        case "LMping": {
          this.dataService.actualizarLMping(dispositivo);
          break;
        }
        case "TcpBus": {
          this.dataService.actualizarTcpBus(dispositivo);
          break;
        }
        case "TcpDevice": {
          this.dataService.actualizarTcpDevice(dispositivo);
          break;
        }
        case "MbBus": {
          this.dataService.actualizarMbBus(dispositivo);
          break;
        }
        case "MbRtuDevice": {
          this.dataService.actualizarMbRtuDevice(dispositivo);
          break;
        }
        default:
          break;
      }
    });
  }

  filterTable(
    filterMode,
    dataSource,
    parameter = null,
    operation = null,
    value = null,
    event = null
  ) {
    switch (filterMode) {
      case "filter":
        switch (dataSource) {
          case "dataSourceSources":
            eval(
              "this." +
                dataSource +
                ".data = this." +
                dataSource +
                ".data.filter(df => df[parameter]" +
                operation +
                value +
                ")"
            );
            break;
          case "dataSourceTo":
            eval(
              "this." +
                dataSource +
                ".data = this." +
                dataSource +
                ".data.filter(df=>df." +
                parameter +
                operation +
                value +
                ")"
            );
            break;
        }
        break;
      case "showFullTable":
        switch (dataSource) {
          case "dataSourceSources":
            this.getDataSources();
            break;
          case "dataSourceTo":
            this.getGatewaysTo();
            break;
        }
        break;
    }
  }

  ngOnDestroy() {
    // Cerramos el stream de datos para no tener problemas de memoria:
    this.subStream.unsubscribe();
  }
}
